// Remove loader that appears before a link
// optionally name class of the loader
function removeLoader(link, loaderClass){
  var ldrClass = (loaderClass) ? loaderClass : "loader";

  var loader =  (link.querySelector("."+ldrClass)) ? link.querySelector("."+ldrClass) : null;
  if(loader) loader.parentNode.removeChild(loader);
}